import { render, staticRenderFns } from "./Restoration.vue?vue&type=template&id=086a0791&scoped=true"
import script from "./Restoration.vue?vue&type=script&lang=js"
export * from "./Restoration.vue?vue&type=script&lang=js"
import style0 from "./Restoration.vue?vue&type=style&index=0&id=086a0791&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086a0791",
  null
  
)

export default component.exports